import React, { Component } from "react";
import { connect } from "react-redux";
import EmptyCart from "./EmptyCart";
import CartItemFeatured from "./CartItemFeatured";
import standardHotel from "../../Images/hotels/sylwia-pietruszka-218324-unsplash.jpg";
import hotelOption1 from "../../Images/hotels/feliperizo-co-heart-made-505565-unsplash.jpg";
import hotelOption2 from "../../Images/hotels/sasha-stories-267941-unsplash.jpg";
import hotelOption3 from "../../Images/hotels/sidny-see-491852-unsplash.jpg";
import { differentHotel } from "../Store/Actions/EuropeActions";
import { asiaDifferentHotel } from "../Store/Actions/AsiaActions";
import { americaDifferentHotel } from "../Store/Actions/AmericaActions";

class BetterHotel extends Component {
  render() {
    const europeInCart = this.props.europeData
      .map(item => (item.inCart ? item : "fail"))
      .filter(checkNull);
    const asiaInCart = this.props.asiaData
      .map(item => (item.inCart ? item : "fail"))
      .filter(checkNull);
    const americaInCart = this.props.americaData
      .map(item => (item.inCart ? item : "fail"))
      .filter(checkNull);
    function checkNull(arr) {
      return arr !== "fail";
    }
    const itemsInCart = europeInCart.concat(asiaInCart, americaInCart);
    const dispayItems = itemsInCart.map((item, i, arr) =>
      arr.length - 1 === i ? (
        <CartItemFeatured
          key={item.id}
          item={item}
          standardOptionValue={item.standardHotel}
          standardImg={standardHotel}
          option1={hotelOption1}
          Option1Value={item.hotelOption1}
          Option1Description="Cozy hotel"
          option2={hotelOption2}
          Option2Value={item.hotelOption2}
          Option2Description="Cozy apartament"
          option3={hotelOption3}
          Option3Value={item.hotelOption3}
          Option3Description="Luxurious hotel"
          choosenValue={item.choosenHotel}
          handleChange={
            item.continent === "europe"
              ? this.props.differentHotel
              : item.continent === "asia"
              ? this.props.asiaDifferentHotel
              : this.props.americaDifferentHotel
          }
          line = {false}
        />
      ) : (
        <CartItemFeatured
          key={item.id}
          item={item}
          standardOptionValue={item.standardHotel}
          standardImg={standardHotel}
          option1={hotelOption1}
          Option1Value={item.hotelOption1}
          Option1Description="Cozy hotel"
          option2={hotelOption2}
          Option2Value={item.hotelOption2}
          Option2Description="Cozy apartament"
          option3={hotelOption3}
          Option3Value={item.hotelOption3}
          Option3Description="Luxurious hotel"
          choosenValue={item.choosenHotel}
          handleChange={
            item.continent === "europe"
              ? this.props.differentHotel
              : item.continent === "asia"
              ? this.props.asiaDifferentHotel
              : this.props.americaDifferentHotel
          }
          line={true}
        />
      )
    );
    console.log(itemsInCart);
    return (
      <React.Fragment>
        <div className="hotels-parallax parallax d-flex justify-content-center align-items-center">
          <h1 className="main-photo-text">Different hotel</h1>
        </div>
        <div className="container mt-4">
          <div className="card">
            <div className="card-body">
              {itemsInCart.length === 0 ? (
                <EmptyCart />
              ) : (
                <h2 className="text-center card-title">Items in cart</h2>
              )}
              {dispayItems}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  europeData: state.europe,
  asiaData: state.asia,
  americaData: state.america
});

const mapDispatchToProps = dispatch => {
  return {
    differentHotel: (id, data) => {
      dispatch(differentHotel(id, data));
    },
    asiaDifferentHotel: (id, data) => {
      dispatch(asiaDifferentHotel(id, data));
    },
    americaDifferentHotel: (id, data) => {
      dispatch(americaDifferentHotel(id, data));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BetterHotel);
